<div class="size-full">
  @if (loadingService.isLoading | async) {
    <palantir-progress-bar
      class="fixed top-0 z-[999999] self-stretch"
      mode="indeterminate"
      style="width: 100%"
    ></palantir-progress-bar>
  }

  <router-outlet />
</div>
